/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_HandledInputs */

const en_capture_handled = /** @type {(inputs: Capture_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This calendar event has already been handled.`)
};

const he_capture_handled = /** @type {(inputs: Capture_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירוע היומן הזה כבר טופל.`)
};

/**
* | output |
* | --- |
* | "This calendar event has already been handled." |
*
* @param {Capture_HandledInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_handled = /** @type {((inputs?: Capture_HandledInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_HandledInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_handled(inputs)
	return he_capture_handled(inputs)
});